import { useStoreActions } from 'store/hooks';
// SELECTORS
import * as authSelectors from 'store/selectors/auth';
// ACTIONS
import * as authActions from 'store/actions/auth';

export const useIndexData = () => {
  return {
    validateTokenLoading: authSelectors.useSelectValidateTokenLoading(),
    resetPasswordLoading: authSelectors.useSelectResetPasswordLoading(),
  };
};

export const useActions = () => {
  return useStoreActions({
    ...authActions,
  });
};
